import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

/**
 * Inputs:
 * -------
 * input label?: string
 * input isPreview?: boolean
 * input formName?: string
 * input noteText?: string
 * input isDisabled?: boolean
 * ---------------------------
 * Events:
 * -------
 * output focused
 * output blured
 * output clicked
 * output changed
 */

@Component({
  selector: 'ops-checkbox',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './ops-checkbox.component.html',
  styleUrls: ['./ops-checkbox.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class OpsCheckboxComponent {
  @Input() label?: string;
  @Input() isPreview?: boolean = false;
  @Input() formName?: string;
  @Input() noteText?: string;
  @Input() isDisabled?: boolean = false;
  @Input() value = false;

  @Output() focused = new EventEmitter<void>();
  @Output() blured = new EventEmitter<void>();
  @Output() clicked = new EventEmitter<void>();
  @Output() changed = new EventEmitter<boolean>();

  onFocus() {
    this.focused.emit();
  }

  onBlur() {
    this.blured.emit();
  }

  onClick() {
    this.clicked.emit();
  }

  onChange(event: Event) {
    const target = event.target as HTMLInputElement;
    this.value = target.checked;
    this.changed.emit(this.value);
  }
}
